import React from 'react';

export default function IconCurrentLocation() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8535 0.146461C13.7107 0.00359178 13.4959 -0.03925 13.3091 0.0378824L0.309109 5.40733C0.112446 5.48856 -0.0112667 5.68535 0.000788689 5.89779C0.0128441 6.11023 0.158025 6.29176 0.362616 6.35022L6.03048 7.96973L7.64977 13.6374C7.70823 13.842 7.88976 13.9872 8.1022 13.9992C8.31464 14.0113 8.51144 13.8876 8.59267 13.6909L13.9621 0.690891C14.0392 0.504146 13.9964 0.289331 13.8535 0.146461ZM12.5783 1.42165L8.21672 11.9816L6.9157 7.42793C6.86824 7.26183 6.7384 7.13199 6.5723 7.08453L2.01834 5.7833L12.5783 1.42165Z"
        fill="#142138"
      />
    </svg>
  );
}
